import {useEffect, useRef} from 'react';
import {view, css} from '@sail/ui/deprecated';
import {animate} from '@sail/engine/deprecated';
import {AnimatePresence} from '@sail/engine';
import {ANIMATION_DURATION} from '../animation';

type Props = {
  children: React.ReactNode;
  open: boolean;
  zIndex?: number;
};

export function BottomDrawer({children, open, zIndex = 10}: Props) {
  const divRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let focusTimeoutId: ReturnType<typeof setTimeout>;
    if (open) {
      focusTimeoutId = setTimeout(function () {
        divRef.current?.focus();
      }, 350);
    }

    return () => {
      if (focusTimeoutId) clearTimeout(focusTimeoutId);
    };
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <>
          <view.div
            data-testid="conversations-widget-bottom-drawer"
            css={{
              position: css.value('absolute'),
              zIndex: css.value(zIndex),
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
              opacity: css.value('0.3'),
              backgroundColor: css.value('#000000'),
            }}
          />
          <view.div
            ref={divRef}
            tabIndex={-1}
            css={{
              focusRing: css.value('none'),
              outline: css.value('none'),
              zIndex: css.value(zIndex + 1),
              position: css.value('absolute'),
              right: 0,
              left: 0,
              bottom: 0,
              background: 'surface',
              borderTopLeftRadius: css.value('10px'),
              borderTopRightRadius: css.value('10px'),
              padding: 'medium',
            }}
            uses={[
              animate.in({
                duration: ANIMATION_DURATION,
                transform: 'translateY(calc(100% * 1))',
                easing: 'ease-out',
              }),
              animate.out({
                duration: ANIMATION_DURATION,
                transform: 'translateY(calc(120% * 1))',
                easing: 'ease-in',
              }),
            ]}
          >
            {children}
          </view.div>
        </>
      )}
    </AnimatePresence>
  );
}
